module.exports = __webpack_public_path__ + "media/images/proof_links/colored/odnoklassniki-3fb5dbc172c91554c6839d49e33f82c8.svg";